import { useListContext } from 'react-admin';


const AssetTotal = (props : any) => {
    const {total} = useListContext();
    return (
        <span>{total}</span>
    )};

export default AssetTotal;